import { APP_ENV } from '@/consts/app.const';
import { PropsWithChildren } from 'react';
import { FeatureFlagContext } from './context';

type Props = PropsWithChildren;

const envFlags = {
  'resend-invite-input-phone': APP_ENV !== 'production'
};

export const FeatureFlagsProvider = ({ children }: Props) => {
  return (
    <FeatureFlagContext.Provider
      value={{
        flags: {
          ...envFlags
        }
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
